import React, { useState } from "react";
import { FaLinkedin, FaFacebook, FaInstagram, FaDiscord } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import QuickContactModal from "../modals/QuickContactModal"; // Adjust path if necessary

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState("Gmail");

  const handleOpenModal = (platform: string) => {
    setSelectedPlatform(platform);
    setIsModalOpen(true);
  };

  return (
    <>
      <footer className="bg-black py-8 border-t border-gray-800">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; 2026 John Patrick. All rights reserved.
          </p>

          <div className="flex flex-col items-center md:items-end">
            <div className="flex items-center space-x-6">
              <button
                onClick={() => handleOpenModal("LinkedIn")}
                className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <FaLinkedin size={24} />
              </button>
              <button
                onClick={() => handleOpenModal("Facebook")}
                className="text-gray-400 hover:text-blue-600 transition-colors duration-300"
                aria-label="Facebook"
              >
                <FaFacebook size={24} />
              </button>
              <button
                onClick={() => handleOpenModal("Instagram")}
                className="text-gray-400 hover:text-pink-500 transition-colors duration-300"
                aria-label="Instagram"
              >
                <FaInstagram size={24} />
              </button>
              <button
                onClick={() => handleOpenModal("Discord")}
                className="text-gray-400 hover:text-indigo-400 transition-colors duration-300"
                aria-label="Discord"
              >
                <FaDiscord size={24} />
              </button>
              <button
                onClick={() => handleOpenModal("Gmail")}
                className="text-gray-400 hover:text-red-500 transition-colors duration-300"
                aria-label="Gmail"
              >
                <SiGmail size={24} />
              </button>
            </div>

            {/* Updated Call to Action Text */}
            <p className="text-gray-500 text-xs mt-3 text-center md:text-right max-w-sm">
              Choose your preferred platform, and I'll reach out within 24
              hours.
            </p>
          </div>
        </div>
      </footer>

      <QuickContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        defaultPlatform={selectedPlatform}
      />
    </>
  );
};

export default Footer;
